import { Checkbox } from "../../Checkbox"
import { ResponsiveGrowShrink } from "../../../../../base/styles"
import { SelectGrowShrink } from "./SelectGrowShrink"
import clsx from "clsx"
import { useState } from "react"

export const EditGrowShrink = ({ title, value, className, onChange }:{
    title: string,
    value: ResponsiveGrowShrink,
    className?: string,
    onChange: (value?: ResponsiveGrowShrink) => void
}) => {
    const [responsive, setResponsive] = useState<boolean>();

    return (
        <div className={clsx(className)}>
            <div className="d-flex align-items-end">
                <SelectGrowShrink
                    title={title}
                    className="flex-grow-1 pe-2"
                    onChange={(newValue) => { onChange({ ...value, allSizes: newValue }) }}
                    value={value?.allSizes} />
                <Checkbox
                    title="Responsive"
                    className="fs-8 fw-semibold"
                    value={responsive === true}
                    onChange={setResponsive} />
            </div>

            {responsive &&
                <div className="d-flex flex-row flex-wrap mx-5 my-3">
                    <SelectGrowShrink
                        title="Small"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, small: newValue }) }}
                        value={value?.small} />
                    <SelectGrowShrink
                        title="Medium"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, medium: newValue }) }}
                        value={value?.medium} />
                    <SelectGrowShrink
                        title="Large"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, large: newValue }) }}
                        value={value?.large} />
                    <SelectGrowShrink
                        title="Ex. Large"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, xLarge: newValue }) }}
                        value={value?.xLarge} />
                    <SelectGrowShrink
                        title="Ex. Large +"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, xxLarge: newValue }) }}
                        value={value?.xxLarge} />
                </div>}
        </div>)
}